/**
 * Stands in for `@ionic/core/loader`.
 *
 * Ionic 5's components are lazy-loaded: the Stencil runtime resolves them with
 * `import("./" + bundleId + ".entry.js")`. Rollup cannot analyse a concatenated
 * specifier, so a Vite build emits none of those chunks and every ion-* element
 * silently fails to upgrade.
 *
 * Instead, Ionic's own prebuilt lazy bundle is copied to /ionic and loaded from
 * a script tag in index.html (it locates its chunks relative to that tag, so it
 * cannot be bundled). That bundle defines every ion-* element, ion-icon
 * included, which leaves the copy of the loader that @ionic/react imports with
 * nothing to do -- and it must do nothing, or it would race the script tag and
 * try to register the same tags twice.
 *
 * This goes away when Ionic is removed or upgraded: Ionic 6+ ships a loader
 * whose dynamic import Vite can statically analyse.
 */
export function defineCustomElements(): Promise<void> {
    return Promise.resolve();
}

export function applyPolyfills(): Promise<void> {
    return Promise.resolve();
}
